import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { InvestmentMovementListModule } from '@components/investment-movement-list/investment-movement-list.module';
import { Web2BannerModule } from '@components/web2-banner/web2-banner.module';
import { MarketPageModule } from '@pages/private/market/market.module';
import { FilterMovementsPageModule } from '@pages/private/movements/filter-movements/filter-movements.module';
import { ProfilePageModule } from '@pages/private/profile/profile.module';
import { PasswordInputModule } from '../password-input/password-input.module';
import { SideMenuComponent } from './side-menu.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    PasswordInputModule,
    ReactiveFormsModule,
    RouterModule,
    InvestmentMovementListModule,
    MarketPageModule,
    ProfilePageModule,
    FilterMovementsPageModule,
    Web2BannerModule,
  ],
  declarations: [
    SideMenuComponent,
  ],
  exports: [
    SideMenuComponent,
  ],
})
export class SideMenuModule { }
